import { render, staticRenderFns } from "./RecipeDetailsSection.vue?vue&type=template&id=357e8aa6&scoped=true&"
import script from "./RecipeDetailsSection.vue?vue&type=script&lang=js&"
export * from "./RecipeDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./RecipeDetailsSection.vue?vue&type=style&index=0&id=357e8aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e8aa6",
  null
  
)

export default component.exports